// noinspection JSUnusedGlobalSymbols

/**
  * This file was generated by the GraphQL Code Generator.
  * DO NOT EDIT.
  * @source: graphql-codegen/codegen.yml
 */

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Address = {
  addressFirstLine?: Maybe<Scalars['String']['output']>;
  addressSecondLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isBilling?: Maybe<Scalars['Boolean']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isPayment?: Maybe<Scalars['Boolean']['output']>;
  isPoBox?: Maybe<Scalars['Boolean']['output']>;
  isShipping?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CreditApplication = {
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<CreditApplicationStatus>;
};

export enum CreditApplicationStatus {
  AppraisalInProgress = 'APPRAISAL_IN_PROGRESS',
  CanceledDupe = 'CANCELED_DUPE',
  CanceledHard = 'CANCELED_HARD',
  CanceledSoft = 'CANCELED_SOFT',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  CreditDenied = 'CREDIT_DENIED',
  CreditFreeze = 'CREDIT_FREEZE',
  FinInfoNeeded = 'FIN_INFO_NEEDED',
  InvalidState = 'INVALID_STATE',
  ItemUnderReview = 'ITEM_UNDER_REVIEW',
  ManualReview = 'MANUAL_REVIEW',
  NotPrequalified = 'NOT_PREQUALIFIED',
  OfferAccepted = 'OFFER_ACCEPTED',
  OfferDecisionNeeded = 'OFFER_DECISION_NEEDED',
  OfferRejected = 'OFFER_REJECTED',
  Prequalified = 'PREQUALIFIED',
  PrequalInfoGiven = 'PREQUAL_INFO_GIVEN',
  PrequalItemValued = 'PREQUAL_ITEM_VALUED',
  Shipped = 'SHIPPED',
  VerifyDoc = 'VERIFY_DOC'
}

export type RootMutationType = {
  /** Accept offer of credit (supports all collateral types) */
  acceptCreditOffer?: Maybe<CreditApplication>;
  /** Reject credit offer */
  rejectCreditOffer?: Maybe<CreditApplication>;
  submitDocumentId?: Maybe<CreditApplication>;
};


export type RootMutationTypeAcceptCreditOfferArgs = {
  annualIncome?: InputMaybe<Scalars['Int']['input']>;
  creditApplicationId: Scalars['ID']['input'];
  dob?: InputMaybe<Scalars['String']['input']>;
  ssnItin?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeRejectCreditOfferArgs = {
  creditApplicationId: Scalars['ID']['input'];
};


export type RootMutationTypeSubmitDocumentIdArgs = {
  creditApplicationId: Scalars['ID']['input'];
  documentId: Scalars['String']['input'];
};

export type RootQueryType = {
  /** Get an application by id */
  creditApplication?: Maybe<CreditApplication>;
  /** Get the currently signed-in user */
  currentUser?: Maybe<User>;
};


export type RootQueryTypeCreditApplicationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type User = {
  annualIncome?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  creditApplication?: Maybe<CreditApplication>;
  displayName?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<Address>;
  ssnLastFour?: Maybe<Scalars['String']['output']>;
};

export type AcceptCreditOfferMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
  ssnItin?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  annualIncome?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AcceptCreditOfferMutation = { acceptCreditOffer?: { id?: string | null, status?: CreditApplicationStatus | null } | null };

export type RejectCreditOfferMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
}>;


export type RejectCreditOfferMutation = { rejectCreditOffer?: { status?: CreditApplicationStatus | null } | null };

export type SubmitDocumentIdMutationVariables = Exact<{
  creditApplicationId: Scalars['ID']['input'];
  documentId: Scalars['String']['input'];
}>;


export type SubmitDocumentIdMutation = { submitDocumentId?: { id?: string | null, status?: CreditApplicationStatus | null } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser?: { id?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, phone?: string | null, displayName?: string | null, email?: string | null, dob?: string | null, referralCode?: string | null, annualIncome?: string | null, ssnLastFour?: string | null, billingAddress?: { addressFirstLine?: string | null, addressSecondLine?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, shippingAddress?: { addressFirstLine?: string | null, addressSecondLine?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, creditApplication?: { status?: CreditApplicationStatus | null, id?: string | null } | null } | null };

export type GetBillingAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBillingAddressQuery = { currentUser?: { billingAddress?: { addressFirstLine?: string | null, addressSecondLine?: string | null, city?: string | null, state?: string | null, zip?: string | null, isBilling?: boolean | null, isShipping?: boolean | null } | null } | null };

export type GetCashAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCashAmountQuery = { currentUser?: { creditApplication?: { id?: string | null } | null } | null };

export type GetItemCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetItemCartQuery = { currentUser?: { creditApplication?: { id?: string | null } | null } | null };

export type GetShippingAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShippingAddressQuery = { currentUser?: { shippingAddress?: { addressFirstLine?: string | null, addressSecondLine?: string | null, city?: string | null, state?: string | null, zip?: string | null, isBilling?: boolean | null, isShipping?: boolean | null, isConfirmed?: boolean | null } | null } | null };


export const AcceptCreditOfferDocument = /*#__PURE__*/ gql`
    mutation acceptCreditOffer($creditApplicationId: ID!, $ssnItin: String, $dob: String, $annualIncome: Int) {
  acceptCreditOffer(
    creditApplicationId: $creditApplicationId
    ssnItin: $ssnItin
    dob: $dob
    annualIncome: $annualIncome
  ) {
    id
    status
  }
}
    `;
export type AcceptCreditOfferMutationFn = Apollo.MutationFunction<AcceptCreditOfferMutation, AcceptCreditOfferMutationVariables>;

/**
 * __useAcceptCreditOfferMutation__
 *
 * To run a mutation, you first call `useAcceptCreditOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCreditOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCreditOfferMutation, { data, loading, error }] = useAcceptCreditOfferMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      ssnItin: // value for 'ssnItin'
 *      dob: // value for 'dob'
 *      annualIncome: // value for 'annualIncome'
 *   },
 * });
 */
export function useAcceptCreditOfferMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCreditOfferMutation, AcceptCreditOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCreditOfferMutation, AcceptCreditOfferMutationVariables>(AcceptCreditOfferDocument, options);
      }
export type AcceptCreditOfferMutationHookResult = ReturnType<typeof useAcceptCreditOfferMutation>;
export type AcceptCreditOfferMutationResult = Apollo.MutationResult<AcceptCreditOfferMutation>;
export type AcceptCreditOfferMutationOptions = Apollo.BaseMutationOptions<AcceptCreditOfferMutation, AcceptCreditOfferMutationVariables>;
export const RejectCreditOfferDocument = /*#__PURE__*/ gql`
    mutation rejectCreditOffer($creditApplicationId: ID!) {
  rejectCreditOffer(creditApplicationId: $creditApplicationId) {
    status
  }
}
    `;
export type RejectCreditOfferMutationFn = Apollo.MutationFunction<RejectCreditOfferMutation, RejectCreditOfferMutationVariables>;

/**
 * __useRejectCreditOfferMutation__
 *
 * To run a mutation, you first call `useRejectCreditOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCreditOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCreditOfferMutation, { data, loading, error }] = useRejectCreditOfferMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useRejectCreditOfferMutation(baseOptions?: Apollo.MutationHookOptions<RejectCreditOfferMutation, RejectCreditOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectCreditOfferMutation, RejectCreditOfferMutationVariables>(RejectCreditOfferDocument, options);
      }
export type RejectCreditOfferMutationHookResult = ReturnType<typeof useRejectCreditOfferMutation>;
export type RejectCreditOfferMutationResult = Apollo.MutationResult<RejectCreditOfferMutation>;
export type RejectCreditOfferMutationOptions = Apollo.BaseMutationOptions<RejectCreditOfferMutation, RejectCreditOfferMutationVariables>;
export const SubmitDocumentIdDocument = /*#__PURE__*/ gql`
    mutation submitDocumentId($creditApplicationId: ID!, $documentId: String!) {
  submitDocumentId(
    creditApplicationId: $creditApplicationId
    documentId: $documentId
  ) {
    id
    status
  }
}
    `;
export type SubmitDocumentIdMutationFn = Apollo.MutationFunction<SubmitDocumentIdMutation, SubmitDocumentIdMutationVariables>;

/**
 * __useSubmitDocumentIdMutation__
 *
 * To run a mutation, you first call `useSubmitDocumentIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDocumentIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDocumentIdMutation, { data, loading, error }] = useSubmitDocumentIdMutation({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useSubmitDocumentIdMutation(baseOptions?: Apollo.MutationHookOptions<SubmitDocumentIdMutation, SubmitDocumentIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitDocumentIdMutation, SubmitDocumentIdMutationVariables>(SubmitDocumentIdDocument, options);
      }
export type SubmitDocumentIdMutationHookResult = ReturnType<typeof useSubmitDocumentIdMutation>;
export type SubmitDocumentIdMutationResult = Apollo.MutationResult<SubmitDocumentIdMutation>;
export type SubmitDocumentIdMutationOptions = Apollo.BaseMutationOptions<SubmitDocumentIdMutation, SubmitDocumentIdMutationVariables>;
export const CurrentUserDocument = /*#__PURE__*/ gql`
    query currentUser {
  currentUser {
    id
    firstName
    lastName
    middleName
    phone
    displayName
    email
    dob
    referralCode
    annualIncome
    ssnLastFour
    billingAddress {
      addressFirstLine
      addressSecondLine
      city
      state
      zip
    }
    shippingAddress {
      addressFirstLine
      addressSecondLine
      city
      state
      zip
    }
    creditApplication {
      status
      id
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetBillingAddressDocument = /*#__PURE__*/ gql`
    query getBillingAddress {
  currentUser {
    billingAddress {
      addressFirstLine
      addressSecondLine
      city
      state
      zip
      isBilling
      isShipping
    }
  }
}
    `;

/**
 * __useGetBillingAddressQuery__
 *
 * To run a query within a React component, call `useGetBillingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBillingAddressQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingAddressQuery, GetBillingAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBillingAddressQuery, GetBillingAddressQueryVariables>(GetBillingAddressDocument, options);
      }
export function useGetBillingAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingAddressQuery, GetBillingAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBillingAddressQuery, GetBillingAddressQueryVariables>(GetBillingAddressDocument, options);
        }
export type GetBillingAddressQueryHookResult = ReturnType<typeof useGetBillingAddressQuery>;
export type GetBillingAddressLazyQueryHookResult = ReturnType<typeof useGetBillingAddressLazyQuery>;
export type GetBillingAddressQueryResult = Apollo.QueryResult<GetBillingAddressQuery, GetBillingAddressQueryVariables>;
export const GetCashAmountDocument = /*#__PURE__*/ gql`
    query getCashAmount {
  currentUser {
    creditApplication {
      id
    }
  }
}
    `;

/**
 * __useGetCashAmountQuery__
 *
 * To run a query within a React component, call `useGetCashAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashAmountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCashAmountQuery(baseOptions?: Apollo.QueryHookOptions<GetCashAmountQuery, GetCashAmountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCashAmountQuery, GetCashAmountQueryVariables>(GetCashAmountDocument, options);
      }
export function useGetCashAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCashAmountQuery, GetCashAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCashAmountQuery, GetCashAmountQueryVariables>(GetCashAmountDocument, options);
        }
export type GetCashAmountQueryHookResult = ReturnType<typeof useGetCashAmountQuery>;
export type GetCashAmountLazyQueryHookResult = ReturnType<typeof useGetCashAmountLazyQuery>;
export type GetCashAmountQueryResult = Apollo.QueryResult<GetCashAmountQuery, GetCashAmountQueryVariables>;
export const GetItemCartDocument = /*#__PURE__*/ gql`
    query getItemCart {
  currentUser {
    creditApplication {
      id
    }
  }
}
    `;

/**
 * __useGetItemCartQuery__
 *
 * To run a query within a React component, call `useGetItemCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetItemCartQuery(baseOptions?: Apollo.QueryHookOptions<GetItemCartQuery, GetItemCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemCartQuery, GetItemCartQueryVariables>(GetItemCartDocument, options);
      }
export function useGetItemCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemCartQuery, GetItemCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemCartQuery, GetItemCartQueryVariables>(GetItemCartDocument, options);
        }
export type GetItemCartQueryHookResult = ReturnType<typeof useGetItemCartQuery>;
export type GetItemCartLazyQueryHookResult = ReturnType<typeof useGetItemCartLazyQuery>;
export type GetItemCartQueryResult = Apollo.QueryResult<GetItemCartQuery, GetItemCartQueryVariables>;
export const GetShippingAddressDocument = /*#__PURE__*/ gql`
    query getShippingAddress {
  currentUser {
    shippingAddress {
      addressFirstLine
      addressSecondLine
      city
      state
      zip
      isBilling
      isShipping
      isConfirmed
    }
  }
}
    `;

/**
 * __useGetShippingAddressQuery__
 *
 * To run a query within a React component, call `useGetShippingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShippingAddressQuery(baseOptions?: Apollo.QueryHookOptions<GetShippingAddressQuery, GetShippingAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingAddressQuery, GetShippingAddressQueryVariables>(GetShippingAddressDocument, options);
      }
export function useGetShippingAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingAddressQuery, GetShippingAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingAddressQuery, GetShippingAddressQueryVariables>(GetShippingAddressDocument, options);
        }
export type GetShippingAddressQueryHookResult = ReturnType<typeof useGetShippingAddressQuery>;
export type GetShippingAddressLazyQueryHookResult = ReturnType<typeof useGetShippingAddressLazyQuery>;
export type GetShippingAddressQueryResult = Apollo.QueryResult<GetShippingAddressQuery, GetShippingAddressQueryVariables>;